import React, { useEffect, useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import store, { qs } from "src/store"
import moment from "moment"
import {
  CancelIcon,
  SaveIcon,
  TrashIcon2,
  CopyIcon,
  EditIcon,
} from "./icons-svg"
import { requestJSON } from "src/utils/request-module"
import PrivateIcon from "./private-icon"
import CustomCard from "./custom-card"
import { getSimulationURL } from "../utils/get-simulation-library-url"
import PassFailChips from "./pass-fail-chips"
import { CircularProgress, IconButton } from "@material-ui/core"
import InputNumber from "./input-number"
import InlineConfirmation from "./inline-confirmation"
import InputText from "./input-text"
import PublicIcon from "./public-icon"
import consts from "shared/consts"
import Tooltip from "./tooltip"
import useFeature from "../utils/subscriptionWrapper"
import useIsLoggedIn from "../utils/use-is-logged-in"
import RenameCopiedSimulation from "./rename-copied-simulation"
import InputCheckBox from "./input-checkbox"
import copyToClipboard from "copy-to-clipboard"
import CustomChip from "./custom-chip"

const useStyles = makeStyles({
  root: {
    marginBottom: "8px",
    height: "max-content",
    display: "flex",
    padding: "14px 20px",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    borderRadius: "5px",
  },
  child: {
    flex: "1",
    padding: "5px",
  },
  rowParent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-around",
    width: "100%",
    height: "100%",
  },
  content: {
    flex: "1 0 auto",
    height: "100%",
    padding: "0px !important",
  },
  rightIcon: {
    float: "right",
  },
  staticText: {
    color: "#717178",
  },
  icon: {
    display: "inline-block",
    fontSize: "18px",
    color: "#2E2E38",
    marginLeft: "20px",
  },
  emptyicon: {
    display: "inline-block",
    fontSize: "18px",
    color: "#2E2E38",
    marginLeft: "25px",
    padding: "0 13px",
  },
  clickable: {
    cursor: "pointer",
  },
  funcName: {
    fontSize: "0.65rem",
    backgoundColor: "#fff !important",
    border: "none",
    minWidth: "75px",
    minHeight: "23px",
    borderRadius: "100px",
    padding: "2px 13px 3px",
    cursor: "pointer",
  },
  funcContainer: {
    fontSize: "0.6rem",
    marginRight: "5px",
  },
  subSectionContainer: {
    marginTop: "5px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
  },
  functionsTitle: {
    marginBottom: "10px",
    color: "#717178",
    fontSize: "0.70rem",
    marginRight: "10px",
  },
  badge: {
    height: "14px",
    width: "14px",
    fontSize: "0.61rem",
    fontWeight: "bold",
    border: "none",
    background: "none",
    color: "#717178",
    position: "relative",
    right: "2px",
  },
  badgeOne: {
    marginRight: "5px",
  },
})

export default function SimulationCard(props) {
  const classes = useStyles()
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  // const tags = store.limitTags(props.simulation.tags);

  const [listOrder, setlistOrder] = useState()
  const [listOrderHasError, setListOrderHasError] = useState(false)
  const [listOrderHelperText, setListOrderHelperText] = useState("")
  const [showEditSimulationName, setShowEditSimulationName] = useState(false)
  const [updatedSimulationName, setUpdatedSimulationName] = useState("")
  const [updatedSimulationNameHasError, setUpdatedSimulationNameHasError] =
    useState(false)
  const [updatedSimulationNameErrorText, setUpdatedSimulationNameErrorText] =
    useState("")
  const [functionsInUse, setFunctionsInUse] = useState([])
  const [showCopySimulationTitleModal, setShowCopySimulationTitleModal] =
    useState(false)
  const [mouseIsInsideCard, setIconVisibility] = useState(false)

  var user = useIsLoggedIn()

  store.useRerenderIfChange(() => [store.isReadOnly])
  var REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS = useFeature(
    consts.FEATURE_FLAG_REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS,
  )

  useEffect(() => {
    setlistOrder(props?.simulation?.listOrder)
  }, [props?.simulation?.listOrder])

  useEffect(() => {
    let sortFuncs = sortFuncsByOccuranceNum(props?.simulation?.functionsInUse)
    setFunctionsInUse(sortFuncs)
  }, [props?.simulation?.functionsInUse])

  const deleteSimulation = async () => {
    store.removeSimulationById(props.simulation._id, props.isLoggedIn?.name)
    setShowDeleteConfirmation(false)
  }

  const updateListOrder = async (listOrder) => {
    setListOrderHelperText("Saving...")
    try {
      requestJSON("PUT", "/simulation/" + props.simulation._id, {
        listOrder: listOrder ? Number(listOrder) : 0,
        editPriority: true,
      })
        .then((response) => {
          if (response === "" || response === undefined) {
            setListOrderHelperText("Not Saved!")
          } else {
            setListOrderHelperText("Saved!")
          }
        })
        .catch((err) => {
          setListOrderHelperText("Not Saved!")
        })
    } catch (err) {
      console.log("Some error has occured while updating simulation order", err)
      setListOrderHelperText("Not Saved!")
    }
  }

  const onListOrderChange = (value) => {
    setlistOrder(value)
    updateListOrder(value)
  }

  const showUpdateSimulationNameInput = () => {
    setUpdatedSimulationName(props.simulation.name || "Untitled")
    setShowEditSimulationName(true)
    setUpdatedSimulationNameHasError(false)
    setUpdatedSimulationNameErrorText("")
  }

  const onSimulationTitleChange = (value) => {
    setUpdatedSimulationName(value)

    if (!value) {
      setUpdatedSimulationNameHasError(true)
      setUpdatedSimulationNameErrorText("Simulation name is required")
    } else {
      setUpdatedSimulationNameHasError(false)
      setUpdatedSimulationNameErrorText("")
    }
  }

  const updateSimulation = () => {
    if (!updatedSimulationNameHasError) {
      store.updateSimulationMetadataProperty(
        "name",
        updatedSimulationName,
        props.simulation._id,
      )
      store.updateSimulationMaindataProperty(
        "name",
        updatedSimulationName,
        props.simulation._id,
      )
      store.updateOneSimulation(props.simulation._id, {
        name: updatedSimulationName,
      })
      setShowEditSimulationName(false)
    }
  }

  const cancelUpdate = () => {
    setUpdatedSimulationName("")
    setShowEditSimulationName(false)
  }

  const sortFuncsByOccuranceNum = (functionsInUse) => {
    if (!functionsInUse) return []
    functionsInUse?.sort((funcA, funcB) => {
      if (funcA.numOfOccurances > funcB.numOfOccurances) {
        return -1
      }
      if (funcA.numOfOccurances < funcB.numOfOccurances) {
        return 1
      }
      // a must be equal to b
      return 0
    })
    return functionsInUse
  }

  const onSubmitCopiedSimulationName = async (newValue) => {
    if (!newValue) {
      return
    } else {
      let reqBody = {
        public: !REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS,
        simulationName: newValue,
        storyId: props.simulation._id,
        stayInSamePage: false,
      }
      try {
        await store.duplicate(reqBody)
        setShowCopySimulationTitleModal(false)
        store.fetchSimulationListMetadata()
      } catch (err) {
        console.log("Some error has occured while duplicating simulation ", err)
      }
    }
  }

  const goToOneSimulation = () => {
    store.createLog({
      simulationId: props.simulation._id,
      operation: "Open",
    })
    store.history.push(getSimulationURL({ simulationId: props.simulation._id }))
  }

  const changeSimulationSelection = () => {
    if (store.selectedSimulationList[props.simulation._id]) {
      delete store.selectedSimulationList[props.simulation._id]
    } else {
      store.selectedSimulationList[props.simulation._id] = true
    }
    store.updateStore()
  }
  var pass_expections = store.simulations.find(
    (x) => x._id == props.simulation._id,
  )?.pass_expections
  var loading_expections = store.simulations.find(
    (x) => x._id == props.simulation._id,
  )?.loading_expections

  store.useRerenderIfChange(() => [
    store.simulations.find((x) => x._id == props.simulation._id)
      ?.loading_expections,
    store.simulations.find((x) => x._id == props.simulation._id)
      ?.pass_expections,
    store.selectedSimulationList,
    store.selectedSimulationList[props.simulation._id],
  ])

  let isSimulationReadOnly =
    !store.getUser() ||
    (store.getUser() &&
      store.getUser()?.email != props.simulation.user &&
      !qs().review_id)

  return (
    <>
      {showCopySimulationTitleModal && (
        <RenameCopiedSimulation
          initialName={props.simulation?.name}
          onClose={() => {
            setShowCopySimulationTitleModal(false)
          }}
          onSubmit={(value) => {
            onSubmitCopiedSimulationName(value)
          }}
          showModal={showCopySimulationTitleModal}
        />
      )}
      <CustomCard
        className={classes.root}
        onMouseEnter={() => {
          setIconVisibility(true)
        }}
        onMouseLeave={() => {
          setIconVisibility(false)
        }}
        onClick={() => goToOneSimulation()}
        css={`
          ${store.selectedSimulationList[props.simulation._id]
            ? `
                background-color: #deebff!important;
                .MuiIconButton-label {
                  color:black;
                }`
            : ""}
        `}
      >
        <div
          css="display: flex;
                    align-items: center;
                    justify-content: space-between;"
          style={
            (mouseIsInsideCard ||
              store.selectedSimulationList[props.simulation._id]) &&
            qs().review_id
              ? { visibility: "visible" }
              : { visibility: "hidden" }
          }
        >
          <div onClick={(e) => e.stopPropagation()}>
            <InputCheckBox
              checked={store.selectedSimulationList[props.simulation._id]}
              onChange={(value) => {
                changeSimulationSelection()
              }}
              label={""}
            />
          </div>
        </div>
        <div css="height: 100%; flex-grow: 1;">
          <div className={classes.rowParent}>
            <div
              css="display: flex;    
                            align-items: center;
                            justify-content: flex-start;
                            width: 100%;
                            "
            >
              {props.simulation.sid && (
                <span
                  css={`
                    opacity: 0.8;
                    cursor: default;
                  `}
                  onClick={(e) => {
                    copyToClipboard(
                      "S" + String(props.simulation.sid).padStart(3, "0"),
                    )
                    e.stopPropagation()
                  }}
                >
                  S{String(props.simulation.sid).padStart(3, "0")}&nbsp;&nbsp;
                </span>
              )}
              {showEditSimulationName ? (
                <div css="width: 100%;" onClick={(e) => e.stopPropagation()}>
                  <form onSubmit={() => updateSimulation()}>
                    <div css="display: flex; align-items: center; justify-content: flex-start;">
                      <div css="width: 100%;flex-grow:1">
                        <InputText
                          autofocus
                          id={"editSimulationName"}
                          value={updatedSimulationName}
                          onChange={(value) => {
                            if (value.trim().length < 201) {
                              onSimulationTitleChange(value)
                            }
                          }}
                          hasError={updatedSimulationNameHasError}
                          errorText={updatedSimulationNameErrorText}
                        />
                      </div>
                      <div>
                        <span
                          className={`${classes.icon} ${classes.clickable}`}
                          onClick={(e) => {
                            updateSimulation()
                            e.stopPropagation()
                          }}
                        >
                          {SaveIcon}
                        </span>
                      </div>
                      <div style={{ marginRight: "20px" }}>
                        <span
                          className={`${classes.icon} ${classes.clickable}`}
                          onClick={(e) => {
                            cancelUpdate()
                            e.stopPropagation()
                          }}
                        >
                          {CancelIcon}
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <>
                  <div
                    css="display: flex;    
                    align-items: center;
                    justify-content: flex-start;"
                  >
                    <div
                      css={
                        isSimulationReadOnly
                          ? `                                                
                            display:flex;
                            align-items: center;
                            .btn {visibility:hidden;}`
                          : `display:flex;
                            align-items: center;
                            .btn {visibility:hidden;}
                            :hover .btn {
                                visibility:visible;
                            }`
                      }
                    >
                      <div
                        css={`
                          color: inherit;
                          text-decoration: inherit;
                          font-size: 18px;
                          cursor: pointer;
                        `}
                      >
                        {props.simulation.name || "Untitled"}
                      </div>
                      &nbsp;
                      {!isSimulationReadOnly && user.isLoggedIn && (
                        <div
                          className="btn"
                          onClick={(e) => {
                            showUpdateSimulationNameInput()
                            e.stopPropagation()
                          }}
                        >
                          <Tooltip tip={"Edit simulation title"}>
                            {EditIcon(20)}
                          </Tooltip>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div>
                {loading_expections && <CircularProgress size={16} />}
                {!loading_expections && (
                  <PassFailChips pass_expections={pass_expections} />
                )}
              </div>
              <div css="margin-left: 10px !important;">
                {!props.simulation.public ? (
                  <Tooltip tip={consts.private_tip}>
                    <span>
                      <PrivateIcon />
                    </span>
                  </Tooltip>
                ) : (
                  <>
                    {!qs().review_id && (
                      <Tooltip tip={consts.public_tip}>
                        <span>
                          <PublicIcon />
                        </span>
                      </Tooltip>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className={classes.subSectionContainer}>
              <div
                css={`
                  display: flex;
                  align-items: center;
                  justify-content: start;
                  font-size: 0.75rem;
                `}
              >
                <div css="padding-right: 5px">
                  <span className={classes.staticText}>Created by:</span>{" "}
                  <span
                    onClick={(e) => {
                      store.clickUser(props.simulation.userName)
                      e.stopPropagation()
                    }}
                    css={`
                      cursor: pointer;
                    `}
                  >
                    {props.simulation.userName}
                  </span>
                </div>
                <div css="padding-right: 5px">-</div>
                <div className={classes.staticText} css="padding-right: 5px">
                  <Tooltip
                    tip={moment(props.simulation.created).format(
                      "MMM-DD-YYYY | hh:mm:ss A",
                    )}
                  >
                    {moment(props.simulation.created).fromNow()}
                  </Tooltip>
                  .
                </div>
                <div css="padding-right: 5px">|</div>
                <div css="padding-right: 5px">
                  <span className={classes.staticText}>Last modified:</span>
                </div>
                <div css="padding-right: 5px">
                  <Tooltip
                    tip={moment(props.simulation.modified).format(
                      "MMM-DD-YYYY | hh:mm:ss A",
                    )}
                  >
                    {moment(props.simulation.modified).fromNow()}
                  </Tooltip>
                  .
                </div>
                {(props.simulation.numOfSteps ||
                  props.simulation.numOfSteps === 0) && (
                  <div>
                    <span css="padding-right: 5px">|</span>
                    <span css="padding-right: 5px">
                      <span className={classes.staticText}>
                        Number of steps:{" "}
                      </span>
                      <span>{props.simulation.numOfSteps}</span>
                    </span>
                  </div>
                )}
                {props.simulation["template_id"] ? (
                  <div>
                    <span css="padding-right: 5px">|</span>
                    <span css="padding-right: 5px">
                      <span className={classes.staticText}>
                        Copied from template:{" "}
                      </span>
                      <span>{props.simulation.template_data.name}</span>
                    </span>
                  </div>
                ) : null}

                {/* <AvatarByUserName userName={props.simulation.userName} size="small" /> */}
              </div>
            </div>
            <div className={classes.subSectionContainer}>
              {functionsInUse &&
                !!functionsInUse.length &&
                functionsInUse.map((func, index) => (
                  <>
                    <CustomChip
                      label={
                        func.name +
                        (func.numOfOccurances > 1
                          ? " x " + func.numOfOccurances
                          : "")
                      }
                      disabled={!props.isLoggedIn || !qs().review_id}
                      onClick={(e) => {
                        if (props.isLoggedIn) {
                          e.stopPropagation()
                          store.updateSimulationFilter("function", func.name)
                        }
                      }}
                    />
                  </>
                ))}
            </div>
          </div>
        </div>
        {(window["config"].EDIT_PRIORITY === "true" ||
          window["config"].EDIT_PRIORITY === true) &&
        props.isLoggedIn &&
        props.isLoggedIn?.email == props.simulation.user &&
        !qs().review_id ? (
          <div>
            <form>
              <div css="display: flex; align-items: center;">
                <div css="width: 50%">
                  <InputNumber
                    id={"editListOrder"}
                    fullWidth={true}
                    value={listOrder}
                    onChange={onListOrderChange}
                    hasError={listOrderHasError}
                    errorText={listOrderHelperText}
                  />
                </div>
              </div>
            </form>
          </div>
        ) : null}
        <div
          css="display: flex;
            align-items: center;
            justify-content: space-between;"
        >
          <div>
            {showDeleteConfirmation ? (
              <div css="margin-left: 10px;">
                <InlineConfirmation
                  message={"Are you sure you want to delete this simulation?"}
                  cancelBtnText="No"
                  onCancel={() => {
                    setShowDeleteConfirmation(false)
                  }}
                  confirmationBtnText="Yes"
                  onConfirm={() => {
                    deleteSimulation()
                  }}
                />
              </div>
            ) : (
              <div>
                {!isSimulationReadOnly && user.isLoggedIn && (
                  <>
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        ...(mouseIsInsideCard &&
                        !showEditSimulationName &&
                        !store.selectedSimulationList[props.simulation._id]
                          ? { visibility: "visible" }
                          : { visibility: "hidden" }),
                      }}
                    >
                      <span
                        className={`${classes.icon} ${classes.clickable}`}
                        onClick={async (e) => {
                          e.stopPropagation()
                          if (!user.isLoggedIn) {
                            location.href = window["config"].AUTH_UI
                            return
                          }
                          setShowCopySimulationTitleModal(true)
                        }}
                      >
                        <Tooltip tip={"Clone simulation"}>{CopyIcon()}</Tooltip>
                      </span>
                      <span
                        className={`${classes.icon} ${classes.clickable}`}
                        onClick={(e) => {
                          e.stopPropagation()
                          if (!user.isLoggedIn) {
                            location.href = window["config"].AUTH_UI
                            return
                          }
                          setShowDeleteConfirmation(true)
                        }}
                      >
                        <Tooltip tip={"Delete simulation"}>
                          {TrashIcon2()}
                        </Tooltip>
                      </span>
                    </span>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </CustomCard>
    </>
  )
}
